import { css, jsx, SerializedStyles } from "@emotion/react";
import React from "react";
import { useShimmerEffect } from "./useShimmerEffect";

const positionRelativeStyle = css`
  position: relative;
`;

/**
 * 要素の大きさに合わせたローディング用の表示を作ることができます。
 *
 * **適した要素**
 *
 * - ローディング前から大きさは固定だが、入れる場所によって大きさが変動してしまう要素
 */
export const ShimmerEffect = ({
  children,
  active,
}: {
  children: React.ReactElement<{
    css?: SerializedStyles | SerializedStyles[];
  }>;
  active?: boolean;
}) => {
  const style = useShimmerEffect();
  if (active !== true) {
    return children;
  }

  if (children.props.css) {
    return React.cloneElement(children, {
      ...children.props,

      css: [positionRelativeStyle, children.props.css, style].flat(),
    });
  }
  return jsx(children.type, {
    key: children.key,
    ...children.props,
    css: [positionRelativeStyle, style],
  });
};
